import Vue from "vue";
import Router from "vue-router";
import DetalleCotizacion from "./components/DetalleCotizacion.vue";

import NProgress from "nprogress";
import Home from "./components/Home";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        breadcrumbs: [{ name: "Inicio", link: null }]
      }
    },
    {
      path: "/detalle/:ticket",
      name: "detalle-cotizacion-anonimo",
      component: DetalleCotizacion,
      props: true,
      meta: {
        breadcrumbs: [{ name: "Detalle", link: null }]
      }
    }
  ]
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
